import { argon2id } from 'hash-wasm';
import { encodeBase64, hkdfSha256, randomBytes } from './primitives';

/** Verifier format: version ‖ salt(16) ‖ HKDF(argon2_out) — never store raw Argon2 IKM. */
export const GUEST_PASSWORD_VERIFIER_VERSION = 0x02;
const GUEST_VERIFY_HKDF_INFO = 'shareweb:guest-verify:v1';
const INFO_CONTENT_HKDF_INFO = 'shareweb:info-content:v1';

export async function deriveGuestPasswordKey(
  password: string,
  salt: Uint8Array,
): Promise<Uint8Array> {
  const derived = await argon2id({
    password,
    salt,
    parallelism: 1,
    iterations: 2,
    memorySize: 19456,
    hashLength: 32,
    outputType: 'binary',
  });

  return derived instanceof Uint8Array ? derived : new Uint8Array(derived);
}

export async function buildGuestPasswordVerifier(
  password: string,
  salt: Uint8Array,
): Promise<Uint8Array> {
  const derived = await deriveGuestPasswordKey(password, salt);
  const verifyTag = await hkdfSha256(derived, new Uint8Array(0), GUEST_VERIFY_HKDF_INFO, 32);
  const verifier = new Uint8Array(49);
  verifier[0] = GUEST_PASSWORD_VERIFIER_VERSION;
  verifier.set(salt, 1);
  verifier.set(verifyTag, 17);
  return verifier;
}

export function encodePasswordVerifierBase64(verifier: Uint8Array): string {
  return encodeBase64(verifier);
}

export async function deriveInfoShareContentKey(
  password: string,
  salt: Uint8Array,
): Promise<Uint8Array> {
  const unwrapKey = await deriveGuestPasswordKey(password, salt);
  return hkdfSha256(unwrapKey, new Uint8Array(0), INFO_CONTENT_HKDF_INFO, 32);
}

export function createGuestPasswordSalt(): Uint8Array {
  return randomBytes(16);
}
